export interface ThemeModel {
  name: string;
  id: string;
}

export const createTheme = (theme: ThemeModel) => ({
  ...theme,
});
